module.exports = __webpack_public_path__ + "media/src/img/payment/ApplePay2-6605d0ac793426523fcfad395ef802e1.svg";